import { AlertTriangle, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

interface QueryErrorAlertProps {
  message?: string;
  onRetry?: () => void;
}

export function QueryErrorAlert({ message, onRetry }: QueryErrorAlertProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        Não foi possível carregar a consulta — isto é uma falha, não ausência de
        dados no período.
        {message ? ` ${message}` : ""}
      </span>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          className="ml-auto h-8 border-red-300 bg-white text-red-800 hover:bg-red-100"
          onClick={onRetry}
        >
          <RefreshCw className="mr-1 h-4 w-4" /> Tentar novamente
        </Button>
      )}
    </div>
  );
}

export default QueryErrorAlert;
